<template>
  <div>
    <h5 class="info-text">Cuenta bancaria</h5>

    <form novalidate class="md-layout" id="bank_account_form" @submit.prevent="submit">
      <div class="md-layout-item md-size-100 md-small-size-100">
        <md-field>
          <md-icon>supervised_user_circle</md-icon>
          <label>Beneficiario</label>
          <md-input disabled v-model="provider.commercial_name"></md-input>
        </md-field>
      </div>

      <div class="md-layout-item md-size-25 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('form.bank') && touched.bank },
            { 'md-form-group': true },
            { 'md-error': errors.has('form.bank') },
          ]"
        >
          <md-icon>domain</md-icon>
          <label>Banco</label>
          <md-select
            v-model="form.bank"
            data-vv-name="form.bank"
            name="bank"
            required
            v-validate="modelValidations.bank"
          >
            <md-option v-for="bank in banks" :key="bank.id" :value="bank.id">{{ bank.short_name }}</md-option>
          </md-select>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('form.bank')">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!errors.has('form.bank') && touched.bank">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-25 md-small-size-100">
        <md-field
          :class="[
            {
              'md-valid':
                !errors.has('form.account_number') && touched.account_number,
            },
            { 'md-form-group': true },
            { 'md-error': errors.has('form.account_number') },
          ]"
        >
          <md-icon>attach_money</md-icon>
          <label>Número de cuenta</label>
          <md-input
            v-model="form.account_number"
            data-vv-name="form.account_number"
            type="number"
            name="account_number"
            v-validate="modelValidations.account_number"
          ></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('form.account_number')">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon
              class="success"
              v-show="
                !errors.has('form.account_number') && touched.account_number
              "
            >done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-25 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('form.clabe') && touched.clabe },
            { 'md-form-group': true },
            { 'md-error': errors.has('form.clabe') },
          ]"
        >
          <md-icon>account_balance</md-icon>
          <label>CLABE</label>
          <md-input
            v-model="form.clabe"
            data-vv-name="form.clabe"
            type="number"
            name="clabe"
            v-validate="modelValidations.clabe"
          ></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('form.clabe')">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!errors.has('form.clabe') && touched.clabe">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-25 md-small-size-100">
        <md-field
          :class="[
            {
              'md-valid':
                !errors.has('form.card_number') && touched.card_number,
            },
            { 'md-form-group': true },
            { 'md-error': errors.has('form.card_number') },
          ]"
        >
          <md-icon>payment</md-icon>
          <label>Número de tarjeta</label>
          <md-input
            v-model="form.card_number"
            data-vv-name="form.card_number"
            type="number"
            name="card_number"
            v-validate="modelValidations.card_number"
          ></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('form.card_number')">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon
              class="success"
              v-show="!errors.has('form.card_number') && touched.card_number"
            >done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-100 mx-auto md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('form.reference') && touched.reference },
            { 'md-form-group': true },
            { 'md-error': errors.has('form.reference') },
          ]"
        >
          <md-icon>send</md-icon>
          <label>Referencia</label>
          <md-input
            v-model="form.reference"
            data-vv-name="form.reference"
            type="text"
            name="reference"
            v-validate="modelValidations.reference"
          ></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('form.reference')">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon
              class="success"
              v-show="!errors.has('form.reference') && touched.reference"
            >done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </form>

    <div class="md-layout">
      <div class="md-layout-item md-size-25 mx-auto">
        <md-button type="submit" form="bank_account_form" class="md-success">Continuar</md-button>
      </div>
    </div>
  </div>
</template>
<script>
import catalogService from "@/services/catalog";
import { SlideYDownTransition } from "vue2-transitions";

const touched = {
  bank: false,
  account_number: false,
  clabe: false,
  card_number: false,
};

const modelValidations = {
  bank: {
    required: true,
  },
  account_number: {
    required: true,
    numeric: true,
    min: 12,
    max: 15,
  },
  clabe: {
    required: true,
    numeric: true,
    min: 18,
    max: 18,
  },
  card_number: {
    required: false,
    numeric: true,
    min: 16,
    max: 18,
  },
  reference: {},
};

export default {
  name: "SecondStep",
  components: { SlideYDownTransition },
  props: {
    provider: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        bank: null,
        account_number: null,
        clabe: null,
        card_number: null,
      },
      banks: [],
      touched,
      modelValidations,
    };
  },
  mounted() {
    catalogService.fetch("banks").then((res) => (this.banks = res));
  },
  methods: {
    submit() {
      if (this.isValid()) {
        this.$http
          .post(
            `catalogs/providers/${this.provider.provider_number}/account/`,
            this.form
          )
          .then((res) => {
            this.$emit("success", {});
          })
          .catch(this.$fireErrorResponse);
      }
    },
    isValid() {
      return this.$validator.validateAll().then((res) => res);
    },
  },
  watch: {
    "form.bank": function () {
      this.touched.bank = true;
    },
    "form.account_number": function () {
      this.touched.account_number = true;
    },
    "form.clabe": function () {
      this.touched.clabe = true;
    },
    "form.card_number": function () {
      this.touched = true;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/Providers/wizard/SecondStep.vue